<template>
    <Modal :modal="modal.filter" :action="() => _trigger()">
        <ModalBody>
            <FilterContainer :label="'Driver'">
                <selectize
                    class="form-control"
                    v-model="filter.driver_id"
                    placeholder="Pilih Driver"
                    :multiple="true"
                >
                    <option
                        v-for="(driver, i) in drivers"
                        :key="i"
                        v-html="driver.nama_driver"
                        :value="driver.id"
                    />
                </selectize>
            </FilterContainer>
            <FilterContainer :label="'Start Date'">
                <input type="date" class="form-control" v-model="filter.start_date" />
            </FilterContainer>
            <FilterContainer :label="'End Date'">
                <input type="date" class="form-control" v-model="filter.end_date" />
            </FilterContainer>
        </ModalBody>
        <ModalFooter>
            <ButtonClose :disabled="loading" :action="() => _trigger()" />
            <ButtonSave :disabled="loading" :action="() => _submit()" />
        </ModalFooter>
    </Modal>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FilterContainer from "@/components/filter/filter-container.vue";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        FilterContainer,
    },
    mixins: [helper],
    data() {
        return {
            drivers: [],
        };
    },
    computed: {
        ...mapState(["loading"]),
        ...mapState("distribution_history", {
            modal: (state) => state.modal,
            filter: (state) => state.filter,
            response: (state) => state.response,
        }),
    },
    methods: {
        ...mapActions("distribution_history", ["triggerModal", "getDistributionHistory"]),
        ...mapActions("driver", ["getListAllDriver"]),
        ...mapActions("depo", ["getListDepo"]),
        _trigger() {
            return this.triggerModal("filter");
        },
        _submit() {
            this.getDistributionHistory();
            this._trigger();
        },
        _getDriver() {
            this.getListAllDriver().then((res) => {
                this.drivers = res;
            });
        },
    },
    mounted() {
        this._getDriver();
    },
    created() {},
};
</script>
